// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"5a3fbff8","672":"e7d37d9e"}[chunkId] + ".chunk.css";
};